import {IProgramModule, IProgramModuleItem} from 'redux/intervention/interfaces';

// The one step a patient should do next in a module: the first unfinished item (the first item
// when the module has not started). Null when the module is locked or finished, or when that
// first unfinished item is itself not yet available.
export function getCurrentModuleItem(module: IProgramModule): IProgramModuleItem | null {
  if (module.status !== 'available_not_started' && module.status !== 'in_progress') {
    return null;
  }

  const current = module.items.find((item) => item.status !== 'completed');

  if (!current) {
    return null;
  }

  return current.status === 'available_not_started' || current.status === 'in_progress' ? current : null;
}
